// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 502) return "static/js/502.6323396c3.chunk.js";
	if (chunkId === 777) return "static/js/recorder.6323396c3.chunk.js";
	if (chunkId === 12) return "static/js/profiler.6323396c3.chunk.js";
	if (chunkId === 331) return "static/js/331.6323396c3.chunk.js";
	if (chunkId === 38) return "static/js/38.6323396c3.chunk.js";
	if (chunkId === 506) return "static/js/506.6323396c3.chunk.js";
	if (chunkId === 420) return "static/js/420.6323396c3.chunk.js";
	if (chunkId === 854) return "static/js/854.6323396c3.chunk.js";
	if (chunkId === 725) return "static/js/725.6323396c3.chunk.js";
	if (chunkId === 946) return "static/js/946.6323396c3.chunk.js";
	if (chunkId === 916) return "static/js/916.6323396c3.chunk.js";
	// return url for filenames based on template
	return undefined;
};